export enum ToastTypes {
    Info = 'info',
    Success = 'success',
    Error = 'error',
}

export interface ToastInfo {
    id: string;
    type: ToastTypes,
    title: string;
    body: string;
    autohide?: number|boolean;
}
